/* LSL · Fiches produit : lien « Notice en ligne » de la version choisie, sous la fiche « Pourquoi choisir… » (.lsl-vxi, faite par lsl-cb3.js).
   Version : Proffie, NeoPixel, RGB (lame 58 cm = RGB 4 sons, sinon RGB 16 sons). Rien pour la poignée vide. Chargé par snippets/lsl-pa-hero.liquid. */
(() => {
  'use strict';
  const sec = document.querySelector('.shopify-section--main-product'); if (!sec) return;
  const BASE = '/pages/fonctionnement-des-sabres-laser';
  const ICO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h10l4 4v12H5z"/><path d="M14 4v5h5M8 13h8M8 17h6"/></svg>';
  const verOf = t => {
    t = (t || '').toLowerCase();
    if (/poign[ée]e\s+vide|sans\s+(?:kit\s+)?[ée]lectronique/.test(t)) return '';
    if (/proffie/.test(t)) return 'proffie';
    if (/neo\s?pixel/.test(t)) return 'neopixel';
    if (/rgb/.test(t)) return /58\s?cm/.test(t) ? 'rgb4' : 'rgb16';
    return '';
  };
  function paint() {
    const box = sec.querySelector('.lsl-vxi'); if (!box) return;
    const form = box.closest('form') || box.closest('.product-info') || sec;
    /* texte des options choisies (les boutons radio portent des identifiants, pas le nom de la version) */
    const radios = Array.from(form.querySelectorAll('input[type="radio"][name*="option"]:checked'));
    const picked = (radios.length ? radios.map(i => {
      const l = (i.labels && i.labels[0]) || form.querySelector(`label[for="${i.id}"]`);
      return l ? (l.dataset.vxRaw || l.textContent) : '';
    }) : Array.from(form.querySelectorAll('select')).map(x => (x.selectedOptions[0] || {}).textContent || '')).join(' ');
    const v = box.hidden ? '' : verOf(picked);
    let a = box.querySelector('.lsl-vxi__nt');
    if (!v) { if (a) a.remove(); return; }
    const href = BASE + '?v=' + v;
    if (a && a.getAttribute('href') === href) return;
    if (!a) {
      a = document.createElement('a');
      a.className = 'lsl-vxi__app lsl-vxi__nt';
      a.target = '_blank'; a.rel = 'noopener';
      a.innerHTML = ICO + 'Voir la notice en ligne de cette version';
      box.append(a);
    }
    a.setAttribute('href', href);
  }
  let t = 0;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(paint, 80); }).observe(sec, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'checked'] });
  sec.addEventListener('change', () => setTimeout(paint, 120));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
})();
